module.exports = __webpack_public_path__ + "img/promo-img.2fbc2f8.png";